var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5625C5.45996 0.5625 0.5625 5.45996 0.5625 11.5C0.5625 17.54 5.45996 22.4375 11.5 22.4375C17.54 22.4375 22.4375 17.54 22.4375 11.5C22.4375 5.45996 17.54 0.5625 11.5 0.5625ZM16.2241 7.92822L11.0825 15.0571C11.0107 15.1574 10.9159 15.2392 10.8062 15.2955C10.6964 15.3519 10.5748 15.3813 10.4514 15.3813C10.328 15.3813 10.2064 15.3519 10.0967 15.2955C9.98691 15.2392 9.89218 15.1574 9.82031 15.0571L6.77588 10.8384C6.68311 10.709 6.77588 10.5283 6.93457 10.5283H8.07959C8.32861 10.5283 8.56543 10.6479 8.71191 10.853L10.4502 13.2651L14.2881 7.94287C14.4346 7.74023 14.6689 7.61816 14.9204 7.61816H16.0654C16.2241 7.61816 16.3169 7.79883 16.2241 7.92822Z",
    fill: "#D5D9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnchecked);
export default __webpack_public_path__ + "static/media/icon-unchecked.37ca8009b8e8f02dde8b578b745f21c3.svg";
export { ForwardRef as ReactComponent };